"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-9ac855d7-ff9a-494b-82cd-464a5d37ce14",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 555 226.63",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M468.18,188.66h57.51s21.96,3.79,21.96-19.68v-49.54s12.87-19.68-115.83-48.45c0,0-67.61-63.99-186.5-63.99h-76.12s-24.4,3.45-51.84,23.47c-11.02,8.04-34.57,23.87-98.93,23.87,0,0-11.35,0-11.35,15.13v90.42s-3.78,26.5,46.95,26.5h22.43",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "176.65",
      y1: "188.66",
      x2: "369.73",
      y2: "188.66",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M151.53,182.52c0,20.5-16.61,37.11-37.1,37.11s-37.11-16.61-37.11-37.11,16.61-37.08,37.11-37.08,37.1,16.6,37.1,37.08Z",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M469.18,182.52c0,20.5-16.61,37.11-37.11,37.11s-37.08-16.61-37.08-37.11,16.6-37.08,37.08-37.08,37.11,16.6,37.11,37.08Z",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("polyline", {
      points: "390.4 78.12 155.29 78.12 135.78 58.27",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "244.37",
      y1: "78.12",
      x2: "244.37",
      y2: "7",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "45.38",
      y1: "137.54",
      x2: "8.93",
      y2: "137.54",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "546.25",
      y1: "141.23",
      x2: "509.8",
      y2: "141.23",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    })]
  });
};

exports.default = Icon;